import React from 'react';
import './home.css';
import Banner from './banner/Banner';
import { useTheme } from '../../components/context/ThemeContext';
import ContactRequest from '../../components/contact_request/ContactRequest';

const Home = () => {
    const { theme } = useTheme();
    
    return (
        <div className={`home-container ${theme}`}>
            <Banner />
            
            <div className="company-info-section">
                <div className="info-container">
                    {/*<div className="info-header">*/}
                    {/*    <h2>Welcome to LiDAR Consultants</h2>*/}
                    {/*</div>*/}
                    
                    <div className="info-content">
                        <p>
                            At LiDAR Consultants, we're dedicated to transforming geospatial insights into intelligent, actionable decisions. 
                            Founded in 2022, we've rapidly become a trusted provider of advanced LiDAR solutions, serving key clients including 
                            Orange County Public Works and leading telecommunications providers. Our mission is to empower industries through 
                            precise, AI-enabled LiDAR technology, streamlining processes, and enhancing strategic outcomes.
                        </p>
                        
                        <div className="info-column">
                            <div className="info-box">
                                <h3>Comprehensive LiDAR Solutions</h3>
                                <p>
                                    Our innovative approach combines targeted LiDAR data collection, advanced AI-driven workflow automation, 
                                    and powerful batch and bulk processing capabilities leveraging state-of-the-art data centers. This holistic method 
                                    ensures high-quality, timely, and efficient delivery of geospatial insights tailored specifically to your needs.
                                </p>
                            </div>
                            
                            <div className="info-box">
                                <h3>Why Choose LiDAR Consultants?</h3>
                                <p>
                                    We are committed to staying at the forefront of LiDAR technology, continually integrating emerging innovations 
                                    to deliver unparalleled accuracy, efficiency, and strategic value. Our dedication to client success, combined with 
                                    our expertise and humility, makes us the preferred geospatial partner for industries seeking transformative insights.
                                </p>
                            </div>
                        </div>
                        
                        <div className="info-footer">
                            <p>Join us as we continue to define the future of LiDAR, together.</p>
                            <div className="info-cta">
                                <ContactRequest />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;
